import { compose, isNil, pickAll, prop, propOr } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import acl from 'features/common/acl';
import user from 'features/views/user';

import { advancedSearchModalFields, NAME } from './constants';

const { KCL_DISPLAY_POLICY_LIST_ISP } = acl.constants;

const getRoot = prop(NAME);

export const getSort = compose(propOr(EMPTY_VALUES.STRING, 'sort'), getRoot);
export const getPolicies = compose(propOr(EMPTY_VALUES.ARRAY, 'policies'), getRoot);
export const getSellerNumbers = compose(prop('sellerNumbers'), getRoot);
export const getPermissionISP = createSelector(user.selectors.getPermissions, (permissions) => {
	return !isNil(permissions[KCL_DISPLAY_POLICY_LIST_ISP[0].id]);
});

export const noPoliciesLoaded = createSelector(getPolicies, (policies) => isNilOrEmpty(policies));
export const getSearchedCriterias = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'searchedCriterias'));
export const getSearchedCriteriasFromAdvancedSearch = createSelector(
	getSearchedCriterias,
	pickAll(advancedSearchModalFields),
);

export const getFocusField = createSelector(getRoot, propOr(null, 'focusField'));
